import React from 'react';

/** Lets the editor's host know when an AI refinement dialog is open. */
export const SetRefineContentDialogOpenContext = React.createContext<(isOpen: boolean) => void>(() => {});
